(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["senzo-b2b-savings"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('senzo-b2b-savings-config');
  if (!config) return;
  const selector = '[bss-b2b-product-price], [bss-b2b-variant-price]';
  const badgeClass = 'senzo-b2b-savings';
  const badges = new Map();

  function amount(text) {
    const matches = text.replace(/[\u00a0\u202f'’\s]/g, '').match(/\d[\d.,]*/g);
    if (!matches || matches.length !== 1) return NaN;
    let value = matches[0];
    const last = Math.max(value.lastIndexOf(','), value.lastIndexOf('.'));
    if (last >= 0 && value.length - last - 1 === 2) {
      value = value.slice(0, last).replace(/[.,]/g, '') + '.' + value.slice(last + 1);
    } else {
      value = value.replace(/[.,]/g, '');
    }
    return Number(value);
  }

  function percentage(price) {
    if (price.getAttribute('bss-b2b-product-active') !== 'true') return null;
    const originalNode = Array.from(price.children).find(node =>
      node.style.textDecoration.includes('line-through') || node.style.textDecorationLine === 'line-through'
    );
    if (!originalNode) return null;
    const original = amount(originalNode.textContent);
    const copy = price.cloneNode(true);
    const index = Array.from(price.children).indexOf(originalNode);
    copy.children[index].remove();
    copy.querySelectorAll('.sr-only, .senzo-b2b-savings').forEach(node => node.remove());
    const final = amount(copy.textContent);
    if (!Number.isFinite(original) || !Number.isFinite(final) || original <= 0 || final < 0 || final >= original) return null;
    const result = Math.round((original - final) / original * 100);
    return result > 0 && result <= 100 ? result : null;
  }

  const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['bss-b2b-product-active', 'style', 'bss-b2b-variant-id'] };
  let queued = false;
  let frame;
  function update() {
    queued = false;
    observer.disconnect();
    try {
      for (const [price, badge] of badges) {
        if (!price.isConnected || !badge.isConnected || percentage(price) === null) {
          badge.remove();
          badges.delete(price);
        }
      }
      document.querySelectorAll(selector).forEach(price => {
        if (!price.closest('price-list, .senzo-card-price')) return;
        const pct = percentage(price);
        if (pct === null) return;
        let badge = badges.get(price);
        if (!badge) {
          badge = document.createElement('span');
          badge.className = badgeClass;
          badges.set(price, badge);
        }
        badge.textContent = '−' + pct + ' %';
        badge.setAttribute('aria-label', config.dataset.label.replace('__PCT__', String(pct)));
        if (price.nextElementSibling !== badge) price.after(badge);
      });
    } finally {
      observer.observe(document.body, options);
    }
  }
  const observer = new MutationObserver(records => {
    if (queued) return;
    const relevant = records.some(record => {
      const node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      return node?.closest(selector) || [...record.addedNodes, ...record.removedNodes].some(child =>
        child.nodeType === 1 && (child.matches(selector) || child.querySelector(selector))
      );
    });
    if (relevant) {
      queued = true;
      frame = requestAnimationFrame(update);
    }
  });
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    cancelAnimationFrame(frame);
    queued = false;
  });
  window.addEventListener('pageshow', update);
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
